<adapt-common-shell class="nimbus-shell-wrapper"
                    [options]="commonShellOptions"
                    [extraSidebarClasses]="ExtraSidebarClasses"> </adapt-common-shell>
